import { ServiceResult } from '../models/api-shared.models';
import {
  CreateOrderApprovalRequest,
  GetOrderApprovalsRequest,
  OrderApproval,
  RejectOrderApprovalRequest,
} from '../models/order-approval.models';
import { OrderEntryHeader } from '../models/order-entry-header.models';
import ApiService from './api-service';

class OrderApprovalService extends ApiService {
  private static classInstance: OrderApprovalService;

  private constructor() {
    super('OrderApproval');
  }

  public getOrderApproval(orderEntryHeaderId: string): ServiceResult<OrderApproval> {
    return this.get(`${this.baseUrl}/GetOrderApproval?orderEntryHeaderId=${orderEntryHeaderId}`);
  }

  public getOrderApprovals(request: GetOrderApprovalsRequest): ServiceResult<OrderEntryHeader[]> {
    return this.post(`${this.baseUrl}/GetOrderApprovals`, request);
  }

  public createOrderApproval(request: CreateOrderApprovalRequest): ServiceResult<OrderApproval> {
    return this.post(`${this.baseUrl}/CreateOrderApproval`, request);
  }

  public rejectOrderApproval(request: RejectOrderApprovalRequest): ServiceResult<OrderApproval> {
    return this.post(`${this.baseUrl}/RejectOrderApproval`, request);
  }

  public static getInstance(): OrderApprovalService {
    if (!this.classInstance) {
      this.classInstance = new OrderApprovalService();
    }
    return this.classInstance;
  }
}

export default OrderApprovalService;
